import { useState } from 'react';
import { validateForm } from '../utils/validators';

/**
 * Custom hook for form validation
 * @param {Object} initialData - Initial form data
 * @param {Object} translations - Translation object for error messages
 * @returns {Object} Form state and handlers
 */
export const useFormValidation = (initialData, translations) => {
    const [formData, setFormData] = useState(initialData);
    const [errors, setErrors] = useState({});

    const handleChange = (name, value) => {
        console.log('handleChange called:', name, '=', value);
        const newFormData = { ...formData, [name]: value };
        setFormData(newFormData);

        // Validate the specific field immediately
        const formErrors = validateForm(newFormData, translations);

        if (formErrors[name]) {
            setErrors(prev => ({ ...prev, [name]: formErrors[name] }));
        } else {
            // Clear error if valid
            setErrors(prev => {
                const newErrors = { ...prev };
                delete newErrors[name];
                return newErrors;
            });
        }
    };

    const validate = () => {
        const newErrors = validateForm(formData, translations);
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const resetForm = () => {
        setFormData(initialData);
        setErrors({});
    };

    const setFieldError = (field, error) => {
        setErrors(prev => ({ ...prev, [field]: error }));
    };

    const clearErrors = () => {
        setErrors({});
    };

    return {
        formData,
        errors,
        handleChange,
        validate,
        resetForm,
        setFieldError,
        clearErrors,
        setFormData
    };
};
